<app-header *ngIf="org" [org]="org"></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>
